import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=57822790&scoped=true"
import script from "./CommentThread.vue?vue&type=script&lang=ts"
export * from "./CommentThread.vue?vue&type=script&lang=ts"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=57822790&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57822790",
  null
  
)

export default component.exports